import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { EventLogItem } from '../../types/eventLogs';
import { styled } from '@mui/material/styles';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';

export interface EventLogTableProps {
  items: Array<EventLogItem>;
}

const StyledTable = styled(Table)(() => ({
  minWidth: 400,
}));

const iconStyle = {
  margin: 0,
  verticalAlign: 'middle',
};

const StyledCheckIcon = styled(CheckCircleIcon)({
  color: '#388e3c', // green for INFO
  ...iconStyle,
});

const StyledWarnIcon = styled(WarningIcon)({
  color: '#f57c00', // orange for WARN
  ...iconStyle,
});

const StyledErrorIcon = styled(ErrorIcon)({
  color: '#d32f2f', // red for ERROR/FATAL
  ...iconStyle,
});

const DateCell = styled(TableCell)(() => ({
  fontSize: 13,
  width: 150,
}));

const IconCell = styled(TableCell)(() => ({
  width: 20,
  paddingRight: 0,
}));

const MessageCell = styled(TableCell)(() => ({
  paddingLeft: 10,
  fontSize: 13,
  paddingRight: 0,
  color: '#000000',
}));

const getIcon = (item: EventLogItem) => {
  switch (item.level) {
    case 'INFO':
      return <StyledCheckIcon />;
    case 'WARN':
      return <StyledWarnIcon />;
    case 'ERROR':
    case 'FATAL':
      return <StyledErrorIcon />;
    default:
      return <StyledCheckIcon />;
  }
};

export const EventLogTable = ({ items }: EventLogTableProps) => {
  return (
    <TableContainer
      sx={{ m: 0, p: 0, ml: 0, pl: 0, maxHeight: 160, overflowY: 'auto' }}
    >
      <StyledTable size="small" aria-label="simple table">
        <TableBody>
          {[...items]
            .sort(
              (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
            )
            .map((item, index) => (
              <TableRow key={index}>
                <IconCell component="td" scope="row">
                  {getIcon(item)}
                </IconCell>
                {item.message && item.description ? (
                  <MessageCell component="td" scope="row">
                    {item.message} &nbsp;&nbsp; {item.description}
                  </MessageCell>
                ) : (
                  <MessageCell component="td" scope="row">
                    {item.message}
                  </MessageCell>
                )}
                <DateCell component="td" scope="row">
                  {typeof item.date === 'string'
                    ? item.date
                    : item.date.toISOString()}
                </DateCell>
              </TableRow>
            ))}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};
